import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import { Box, FormControl, InputAdornment, MenuItem, Select, TextField, Typography } from "@mui/material";
import { riskOptions, statusOptions } from "../../utils/orderListUtils";

export const OssOrderToolbar = ({ filters, total, onFilterChange }) => (
  <Box
    className="oss-filter-toolbar"
    sx={{
      minHeight: 58,
      p: { xs: 1.2, sm: 1.5 },
      display: "grid",
      gridTemplateColumns: { xs: "1fr", md: "minmax(260px, 1fr) 180px 160px auto" },
      gap: 1,
      alignItems: "center",
      borderBottom: "1px solid #e6eaf0",
      bgcolor: "#fbfbfe",
    }}
  >
    <TextField
      value={filters.search}
      onChange={(e) => onFilterChange("search", e.target.value)}
      size="small"
      placeholder="주문번호, 거래처, 품목 검색"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchRoundedIcon fontSize="small" />
          </InputAdornment>
        ),
      }}
    />
    <FormControl size="small">
      <Select value={filters.status} displayEmpty onChange={(e) => onFilterChange("status", e.target.value)}>
        {statusOptions.map(([value, label]) => (
          <MenuItem key={value || "all"} value={value}>{label}</MenuItem>
        ))}
      </Select>
    </FormControl>
    <FormControl size="small">
      <Select value={filters.riskLevel} displayEmpty onChange={(e) => onFilterChange("riskLevel", e.target.value)}>
        {riskOptions.map(([value, label]) => (
          <MenuItem key={value || "all"} value={value}>{label}</MenuItem>
        ))}
      </Select>
    </FormControl>
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: { xs: "flex-start", md: "flex-end" }, gap: 0.7 }}>
      <SearchRoundedIcon sx={{ fontSize: 18, color: "#6b7280" }} />
      <Typography sx={{ fontSize: 12.5, color: "#6b7280" }}>
        표시 <Box component="span" sx={{ color: "#111827", fontWeight: 800 }}>{total}</Box>건
      </Typography>
    </Box>
  </Box>
);
